import { atom } from 'jotai';

export type AccountSettings = {
  cookies: {
    required: boolean;
    statistic: boolean;
  };
  twoFactorAuthentication: boolean;
};

export const defaultAccountSettings = {
  cookies: {
    required: false,
    statistic: false,
  },
  twoFactorAuthentication: false,
};

export const accountSettingsAtom = atom<AccountSettings>(defaultAccountSettings);
